import { useState, useRef, useEffect } from "react";

const S = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Noto+Sans+KR:wght@300;400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #fafafa; --white: #ffffff; --border: #efefef; --border2: #dbdbdb;
    --text: #0a0a0a; --muted: #737373; --muted2: #c7c7c7;
    --accent: #0095f6; --accent-h: #1877f2;
    --grad: linear-gradient(45deg, #f09433,#e6683c,#dc2743,#cc2366,#bc1888);
    --radius: 12px; --radius-sm: 8px;
  }
  body { background: var(--bg); color: var(--text); font-family: 'Noto Sans KR', sans-serif; font-weight: 300; -webkit-font-smoothing: antialiased; min-height: 100vh; }

  /* NAV */
  .nav { position: sticky; top: 0; z-index: 100; background: rgba(255,255,255,0.96); backdrop-filter: blur(12px); border-bottom: 1px solid var(--border); height: 56px; display: flex; align-items: center; padding: 0 1.5rem; justify-content: space-between; }
  .nav-logo { display: flex; align-items: center; gap: 0.5rem; cursor: pointer; text-decoration: none; }
  .nav-logo-icon { width: 30px; height: 30px; background: var(--grad); border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1rem; }
  .nav-logo-text { font-family: 'Outfit', sans-serif; font-weight: 700; font-size: 1.05rem; letter-spacing: -0.02em; }
  .nav-logo-text span { color: var(--accent); }
  .nav-back { display: flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; color: var(--muted); cursor: pointer; border: none; background: none; font-family: 'Noto Sans KR', sans-serif; padding: 0; transition: color 0.15s; }
  .nav-back:hover { color: var(--text); }

  /* HERO */
  .hero { background: var(--white); border-bottom: 1px solid var(--border); padding: 3rem 1.5rem 2.5rem; text-align: center; }
  .hero-icon { width: 56px; height: 56px; background: var(--grad); border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 1.6rem; margin: 0 auto 1.2rem; }
  .hero h1 { font-family: 'Outfit', sans-serif; font-size: clamp(1.5rem, 3.5vw, 2rem); font-weight: 700; letter-spacing: -0.03em; margin-bottom: 0.5rem; }
  .hero p { font-size: 0.88rem; color: var(--muted); line-height: 1.65; max-width: 480px; margin: 0 auto; }

  /* MAIN LAYOUT */
  .page { max-width: 680px; margin: 0 auto; padding: 2rem 1.5rem 5rem; }

  /* SEARCH BOX */
  .search-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); padding: 1.5rem; margin-bottom: 1.5rem; }
  .search-label { font-size: 0.72rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--muted); font-family: 'Outfit', sans-serif; margin-bottom: 1rem; }
  .search-row { display: flex; gap: 0.6rem; }
  .search-input-wrap { flex: 1; position: relative; display: flex; align-items: center; }
  .search-at { position: absolute; left: 0.9rem; color: var(--muted); font-size: 0.9rem; font-weight: 500; font-family: 'Outfit', sans-serif; pointer-events: none; }
  .search-input { width: 100%; padding: 0.75rem 0.9rem 0.75rem 1.8rem; border: 1.5px solid var(--border2); border-radius: var(--radius-sm); font-size: 0.9rem; font-family: 'Noto Sans KR', sans-serif; background: var(--bg); color: var(--text); outline: none; transition: border-color 0.18s, box-shadow 0.18s; }
  .search-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(0,149,246,0.1); }
  .search-btn { padding: 0.75rem 1.4rem; background: var(--accent); color: #fff; border: none; border-radius: var(--radius-sm); font-size: 0.88rem; font-family: 'Outfit', sans-serif; font-weight: 600; cursor: pointer; transition: background 0.15s; white-space: nowrap; }
  .search-btn:hover { background: var(--accent-h); }
  .search-btn:disabled { opacity: 0.6; cursor: not-allowed; }
  .popular-wrap { margin-top: 1rem; display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
  .popular-label { font-size: 0.72rem; color: var(--muted); font-family: 'Outfit', sans-serif; }
  .popular-chip { padding: 3px 10px; border: 1px solid var(--border2); border-radius: 100px; font-size: 0.75rem; background: var(--white); cursor: pointer; transition: all 0.12s; font-family: 'Outfit', sans-serif; }
  .popular-chip:hover { border-color: var(--accent); color: var(--accent); background: #f0f8ff; }

  /* NOTICE */
  .notice { background: #fff8f0; border: 1px solid #fde68a; border-radius: var(--radius-sm); padding: 0.85rem 1rem; font-size: 0.78rem; color: #92400e; line-height: 1.6; margin-bottom: 1.5rem; }
  .notice-info { background: #f0f8ff; border-color: #bae6fd; color: #0c4a6e; }

  /* LOADING */
  .loading { text-align: center; padding: 3rem; }
  .spinner { width: 36px; height: 36px; border: 3px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.7s linear infinite; margin: 0 auto 0.8rem; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .loading p { font-size: 0.85rem; color: var(--muted); }

  /* ERROR */
  .error-box { background: #fff0f0; border: 1px solid #fecaca; border-radius: var(--radius-sm); padding: 1rem 1.2rem; font-size: 0.84rem; color: #dc2626; margin-bottom: 1.2rem; }

  /* PROFILE CARD */
  .profile-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; margin-bottom: 1.2rem; }
  .profile-header { padding: 1.5rem; display: flex; align-items: center; gap: 1.2rem; border-bottom: 1px solid var(--border); }
  .avatar-ring { width: 74px; height: 74px; border-radius: 50%; background: var(--grad); padding: 2.5px; flex-shrink: 0; }
  .avatar-inner { width: 100%; height: 100%; border-radius: 50%; background: var(--bg); display: flex; align-items: center; justify-content: center; font-size: 1.8rem; overflow: hidden; }
  .avatar-img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
  .profile-info { flex: 1; min-width: 0; }
  .profile-name-row { display: flex; align-items: center; gap: 0.4rem; margin-bottom: 0.2rem; flex-wrap: wrap; }
  .profile-name { font-family: 'Outfit', sans-serif; font-size: 1.05rem; font-weight: 700; }
  .profile-verified { color: var(--accent); font-size: 1rem; }
  .profile-username { font-size: 0.8rem; color: var(--muted); margin-bottom: 0.4rem; }
  .profile-bio { font-size: 0.82rem; line-height: 1.55; white-space: pre-line; }
  .profile-link { font-size: 0.8rem; color: var(--accent); margin-top: 0.3rem; word-break: break-all; }
  .profile-stats { display: grid; grid-template-columns: 1fr 1fr 1fr; }
  .stat-item { padding: 1rem; text-align: center; border-right: 1px solid var(--border); }
  .stat-item:last-child { border-right: none; }
  .stat-value { font-family: 'Outfit', sans-serif; font-weight: 700; font-size: 1.05rem; margin-bottom: 0.2rem; }
  .stat-label { font-size: 0.7rem; color: var(--muted); }

  /* POSTS GRID */
  .posts-section { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; margin-bottom: 1.2rem; }
  .posts-header { padding: 1rem 1.2rem; border-bottom: 1px solid var(--border); display: flex; align-items: center; gap: 0.5rem; }
  .posts-header-icon { font-size: 0.9rem; }
  .posts-header-label { font-family: 'Outfit', sans-serif; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--muted); }
  .posts-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px; }
  .post-thumb { aspect-ratio: 1; background: var(--bg); position: relative; cursor: pointer; overflow: hidden; }
  .post-thumb img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.2s; display: block; }
  .post-thumb:hover img { transform: scale(1.05); }
  .post-thumb-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.35); display: flex; align-items: center; justify-content: center; gap: 1rem; opacity: 0; transition: opacity 0.18s; }
  .post-thumb:hover .post-thumb-overlay { opacity: 1; }
  .post-overlay-stat { display: flex; align-items: center; gap: 0.3rem; color: #fff; font-size: 0.82rem; font-weight: 600; font-family: 'Outfit', sans-serif; }
  .post-thumb-placeholder { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; background: linear-gradient(135deg, #f0f0f0, #e0e0e0); }
  /* 카드형 포스트 스타일 */
  .post-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; margin-bottom: 1.2rem; }
  .post-card img { width: 100%; display: block; }
  .post-card-info { padding: 0.8rem 1rem; }
  .post-card-caption { font-size: 0.82rem; line-height: 1.4; margin-bottom: 0.6rem; color: var(--text); }
  .post-card-stats { display: flex; gap: 1rem; font-size: 0.78rem; color: var(--muted); }
  .post-card-stats span { display: flex; align-items: center; gap: 0.3rem; }

  .post-comments { margin-top: 0.6rem; padding-left: 1rem; font-size: 0.78rem; color: var(--muted); }
  .post-comment-item { list-style: disc; margin-bottom: 0.3rem; }

  /* 수직 목록으로 구성된 카드형 게시글 컨테이너 */
  .posts-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px; }

  /* STORY HIGHLIGHTS */
  .highlights-section { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; margin-bottom: 1.2rem; }
  .highlights-scroll { display: flex; gap: 1rem; padding: 1rem 1.2rem; overflow-x: auto; scrollbar-width: none; }
  .highlights-scroll::-webkit-scrollbar { display: none; }
  .highlight-item { display: flex; flex-direction: column; align-items: center; gap: 0.4rem; flex-shrink: 0; cursor: pointer; }
  .highlight-ring { width: 56px; height: 56px; border-radius: 50%; background: var(--grad); padding: 2px; }
  .highlight-inner { width: 100%; height: 100%; border-radius: 50%; background: var(--white); display: flex; align-items: center; justify-content: center; font-size: 1.3rem; border: 2px solid var(--white); }
  .highlight-label { font-size: 0.65rem; color: var(--text); text-align: center; max-width: 56px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  /* OPEN BUTTON */
  .open-btn { display: flex; align-items: center; justify-content: center; gap: 0.5rem; width: 100%; padding: 0.85rem; background: var(--accent); color: #fff; border: none; border-radius: var(--radius-sm); font-size: 0.9rem; font-family: 'Outfit', sans-serif; font-weight: 600; cursor: pointer; text-decoration: none; transition: background 0.15s; margin-bottom: 1.2rem; }
  .open-btn:hover { background: var(--accent-h); }

  /* BACKEND STATUS */
  .backend-status { display: flex; align-items: center; gap: 0.5rem; padding: 0.6rem 0.9rem; border-radius: var(--radius-sm); font-size: 0.75rem; font-family: 'Outfit', sans-serif; margin-bottom: 1.2rem; border: 1px solid; }
  .status-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
  .status-online { background: #dcfce7; border-color: #86efac; color: #166534; }
  .status-online .status-dot { background: #22c55e; }
  .status-offline { background: #fff7ed; border-color: #fed7aa; color: #9a3412; }
  .status-offline .status-dot { background: #f97316; }

  /* API INFO */
  .api-info { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); padding: 1.2rem; }
  .api-info-title { font-family: 'Outfit', sans-serif; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--muted); margin-bottom: 0.9rem; }
  .api-endpoint { display: flex; align-items: center; justify-content: space-between; padding: 0.55rem 0.8rem; background: var(--bg); border-radius: 6px; margin-bottom: 0.5rem; font-family: 'Outfit', monospace; font-size: 0.75rem; gap: 0.5rem; }
  .api-method { font-weight: 700; color: var(--accent); flex-shrink: 0; }
  .api-path { color: var(--text); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  @media (max-width: 480px) { .search-row { flex-direction: column; } .profile-header { flex-direction: column; text-align: center; } }
`;

// ── API 설정 ─────────────────────────────────────────────
// 개발/배포 환경 모두 동일한 백엔드 주소를 사용하려면 루트 .env 파일에
// `VITE_API_BASE=https://hjryulab-backend.onrender.com` 처럼 설정합니다.
// Vite는 `npm run dev` 명령으로 실행할 때 .env를 읽습니다. (CRA의
// `npm start`를 쓰면 환경이 로드되지 않습니다.)
// 환경변수가 없으면 기본적으로 실제 배포 URL을 사용하도록 해둡니다.
const API_BASE = import.meta.env.VITE_API_BASE
  ? `${import.meta.env.VITE_API_BASE}/api/instagram`
  : "https://hjryulab-backend.onrender.com/api/instagram";

// 백엔드 없을 때 사용하는 목 데이터
const MOCK_PROFILES = {
  cristiano: { username: "cristiano", fullName: "Cristiano Ronaldo", biography: "⚽ Al-Nassr FC\n🏆 GOAT", followersCount: 620000000, followingCount: 562, postsCount: 3538, isVerified: true, isPrivate: false, profilePicUrl: null, emoji: "⚽", website: "https://www.cristianoronaldo.com", highlights: ["Training","Family","Goals","CR7"], posts: Array.from({length:9},(_,i)=>({ id:i, emoji:["⚽","🏆","🔥","💪","🇵🇹","🙏","👊","😎","🌟"][i], likes: Math.floor(Math.random()*5000000+500000), comments: Math.floor(Math.random()*50000+5000) })) },
  therock: { username: "therock", fullName: "Dwayne Johnson", biography: "🎬 Actor, Producer, Tequila Maker\n💪 Teremana", followersCount: 395000000, followingCount: 821, postsCount: 8234, isVerified: true, isPrivate: false, profilePicUrl: null, emoji: "🎬", website: "https://teremana.com", highlights: ["Movies","Gym","Family","Tequila"], posts: Array.from({length:9},(_,i)=>({ id:i, emoji:["🎬","💪","🥃","🏋️","🌴","😂","🔥","👨‍👧","🙌"][i], likes: Math.floor(Math.random()*3000000+200000), comments: Math.floor(Math.random()*20000+2000) })) },
  nasa: { username: "nasa", fullName: "NASA", biography: "🚀 Explore the universe and discover Earth\n🌍 www.nasa.gov", followersCount: 97800000, followingCount: 67, postsCount: 4231, isVerified: true, isPrivate: false, profilePicUrl: null, emoji: "🚀", website: "https://www.nasa.gov", highlights: ["Mars","Hubble","ISS","Artemis"], posts: Array.from({length:9},(_,i)=>({ id:i, emoji:["🚀","🌍","⭐","🛸","🌙","🔭","💫","🪐","☄️"][i], likes: Math.floor(Math.random()*500000+50000), comments: Math.floor(Math.random()*5000+500) })) },
};

function fmtNum(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1) + "M";
  if (n >= 10000) return (n / 1000).toFixed(0) + "K";
  return n?.toLocaleString() ?? "0";
}

export default function InstagramViewer() {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");
  const [visibleCount, setVisibleCount] = useState(9);
  const [expandedPosts, setExpandedPosts] = useState({});
  const [backendOnline, setBackendOnline] = useState(null);
  const inputRef = useRef();

  // 무한스크롤: 스크롤 바닥 근처에 도달하면 게시글을 추가로 보여줌
  useEffect(() => {
    function onScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const viewportHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      if (scrollY + viewportHeight > fullHeight - 200) {
        setVisibleCount(prev => {
          if (!profile) return prev;
          return Math.min(profile.posts.length, prev + 9);
        });
      }
    }
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [profile]);

  // 이미지 URL을 프록시 URL로 변환
  function proxyImageUrl(url) {
    if (!url) return null;
    if (url.startsWith("data:")) return url; // data URL은 그대로
    // 개발환경에서도 로컬이 아닌 동일한 백엔드(원격)를 바라보도록 기본
    // 값을 배포 URL로 설정. .env에 VITE_API_BASE를 정의했으면 그 값을 씁니다.
    const viteApi = import.meta.env.VITE_API_BASE || "https://hjryulab-backend.onrender.com";
    return `${viteApi}/api/instagram/proxy-image?url=${encodeURIComponent(url)}`;
  }

  // 백엔드 헬스체크
  async function checkBackend() {
    try {
      const res = await fetch(`${API_BASE}/health`, { signal: AbortSignal.timeout(2000) });
      setBackendOnline(res.ok);
      return res.ok;
    } catch {
      setBackendOnline(false);
      return false;
    }
  }

  async function lookup(username) {
    const u = (username || query).trim().replace("@", "").toLowerCase();
    if (!u) return;
    setLoading(true); setError(""); setProfile(null);

    const isOnline = await checkBackend();

    if (isOnline) {
      // ── 실제 백엔드 호출 ──────────────────────────────
      try {
        // 요청시에 게시글 최대 개수 지정 (개발 중 스크롤로 더 보려면 숫자 높게)
        const res = await fetch(`${API_BASE}/profile/${u}?maxPosts=50`);
        if (!res.ok) { const d = await res.json(); throw new Error(d.message || "조회 실패"); }
        let data = await res.json();

        // 로그: 받은 원본 데이터 확인
        console.log("[lookup] original profile data:", data);

        // 프로필 이미지 우선 처리: 항상 프록시 URL을 사용
        if (data.profilePicUrl) {
          const original = data.profilePicUrl;
          data.origProfilePicUrl = original;            // 원본 보관 (fallback 때 사용)
          console.log("[lookup] got profilePicUrl", original);
          const proxied = proxyImageUrl(original);
          data.profilePicUrl = proxied;
          console.log("[lookup] using proxied profilePicUrl", proxied);
        }

        // 게시물 이미지 변환 (간단히 proxyImageUrl만 사용)
        if (data.posts && Array.isArray(data.posts)) {
          data.posts = data.posts.map(post => ({
            ...post,
            imageUrl: proxyImageUrl(post.imageUrl)
          }));
        }

        console.log("[lookup] transformed profile data:", data);
        setProfile(data);
        // reset scroll/page state
        setVisibleCount(9);
        setExpandedPosts({});
      } catch (e) {
        setError(e.message || "프로필을 불러오지 못했습니다.");
      }
    } else {
      // ── 목 데이터 fallback ────────────────────────────
      await new Promise(r => setTimeout(r, 700));
      const mock = MOCK_PROFILES[u] || {
        username: u, fullName: u, biography: "공개 프로필입니다.",
        followersCount: Math.floor(Math.random() * 50000 + 1000),
        followingCount: Math.floor(Math.random() * 500 + 50),
        postsCount: Math.floor(Math.random() * 300 + 10),
        isVerified: false, isPrivate: false, profilePicUrl: null, emoji: "👤",
        website: "", highlights: [], posts: []
      };
      setProfile(mock);
    }
    setLoading(false);
  }

  const POPULAR = ["cristiano", "therock", "nasa", "natgeo", "leomessi"];

  return (
    <>
      <style>{S}</style>

      {/* NAV */}
      <nav className="nav">
        <a className="nav-logo" href="/">
          <div className="nav-logo-icon">📸</div>
          <span className="nav-logo-text"><span>hjryu</span>lab</span>
        </a>
        <button className="nav-back" onClick={() => window.history.back()}>
          ← 돌아가기
        </button>
      </nav>

      {/* HERO */}
      <div className="hero">
        <div className="hero-icon">📸</div>
        <h1>인스타그램 익명 뷰어</h1>
        <p>공개 계정의 프로필과 게시물을 로그인 없이 확인하세요.<br />상대방에게 방문 사실이 전달되지 않습니다.</p>
      </div>

      <div className="page">

        {/* 백엔드 상태 */}
        {backendOnline !== null && (
          <div className={`backend-status ${backendOnline ? "status-online" : "status-offline"}`}>
            <div className="status-dot" />
            {backendOnline ? "백엔드 서버 연결됨 — 실제 인스타그램 데이터 조회 중" : "백엔드 오프라인 — 데모 데이터로 표시됩니다 (백엔드 서버를 실행해주세요)"}
          </div>
        )}

        {/* 안내 */}
        <div className="notice">
          ⚠️ <strong>공개(Public) 계정만</strong> 조회 가능합니다. 비공개 계정은 조회되지 않습니다.
        </div>

        {/* 검색 */}
        <div className="search-card">
          <div className="search-label">계정 검색</div>
          <div className="search-row">
            <div className="search-input-wrap">
              <span className="search-at">@</span>
              <input
                ref={inputRef}
                className="search-input"
                type="text"
                placeholder="사용자명 입력 (예: cristiano)"
                value={query}
                onChange={e => setQuery(e.target.value)}
                onKeyDown={e => e.key === "Enter" && lookup()}
              />
            </div>
            <button className="search-btn" onClick={() => lookup()} disabled={loading}>
              {loading ? "조회 중..." : "조회"}
            </button>
          </div>
          <div className="popular-wrap">
            <span className="popular-label">인기 계정:</span>
            {POPULAR.map(u => (
              <span key={u} className="popular-chip" onClick={() => { setQuery(u); lookup(u); }}>@{u}</span>
            ))}
          </div>
        </div>

        {/* 로딩 */}
        {loading && (
          <div className="loading">
            <div className="spinner" />
            <p>프로필을 불러오는 중...</p>
          </div>
        )}

        {/* 에러 */}
        {error && <div className="error-box">❌ {error}</div>}

        {/* 프로필 결과 */}
        {profile && !loading && (
          <>
            {/* 프로필 카드 */}
            <div className="profile-card">
              <div className="profile-header">
                <div className="avatar-ring">
                  <div className="avatar-inner">
                    {profile.profilePicUrl
                      ? <img
                          className="avatar-img"
                          src={profile.profilePicUrl}
                          alt="avatar"
                          crossOrigin="anonymous"
                          onError={e => {
                            // 첫 시도에서 실패하면 공개 CORS 프록시로 재시도
                            const current = e.target.src;
                            if (!current.includes('allorigins.win')) {
                              const orig = profile.origProfilePicUrl || profile.profilePicUrl;
                              e.target.src = `https://api.allorigins.win/raw?url=${encodeURIComponent(orig)}`;
                            } else {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display = "flex";
                            }
                          }}
                        />
                      : null}
                    <span style={{ display: profile.profilePicUrl ? "none" : "flex" }}>{profile.emoji || "👤"}</span>
                  </div>
                </div>
                <div className="profile-info">
                  <div className="profile-name-row">
                    <span className="profile-name">{profile.fullName}</span>
                    {profile.isVerified && <span className="profile-verified">✓</span>}
                    {profile.isPrivate && <span style={{ fontSize: "0.7rem", background: "#f3f4f6", color: "#6b7280", padding: "2px 7px", borderRadius: "100px", fontFamily: "Outfit" }}>🔒 비공개</span>}
                  </div>
                  <div className="profile-username">@{profile.username}</div>
                  {profile.biography && <div className="profile-bio">{profile.biography}</div>}
                  {profile.website && <div className="profile-link">🔗 {profile.website}</div>}
                </div>
              </div>
              <div className="profile-stats">
                {[["게시물", profile.postsCount], ["팔로워", profile.followersCount], ["팔로잉", profile.followingCount]].map(([l, v]) => (
                  <div key={l} className="stat-item">
                    <div className="stat-value">{fmtNum(v)}</div>
                    <div className="stat-label">{l}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* 하이라이트 */}
            {profile.highlights?.length > 0 && (
              <div className="highlights-section">
                <div className="posts-header">
                  <span className="posts-header-icon">⭕</span>
                  <span className="posts-header-label">스토리 하이라이트</span>
                </div>
                <div className="highlights-scroll">
                  {profile.highlights.map((h, i) => (
                    <div key={i} className="highlight-item">
                      <div className="highlight-ring">
                        <div className="highlight-inner">
                          {["🏆","📸","🌟","💫","🎯","🔥","💎","🎬"][i % 8]}
                        </div>
                      </div>
                      <span className="highlight-label">{h}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* 게시물 그리드 */}
            {profile.posts?.length > 0 && (
              <div className="posts-section">
                <div className="posts-header">
                  <span className="posts-header-icon">⊞</span>
                  <span className="posts-header-label">최근 게시물</span>
                </div>
                <div className="posts-grid">
                  {profile.posts.slice(0, visibleCount).map((post, i) => (
                    <div key={i} className="post-card">
                      {post.imageUrl
                        ? <img src={post.imageUrl} alt="" loading="lazy" crossOrigin="anonymous" />
                        : <div className="post-thumb-placeholder">{post.emoji || "📷"}</div>}
                      <div className="post-card-info">
                        {post.caption && <div className="post-card-caption">{post.caption}</div>}
                        <div className="post-card-stats">
                          <span>❤️ {fmtNum(post.likes)}</span>
                          <span
                            style={{ cursor: post.commentSamples ? 'pointer' : 'default' }}
                            onClick={() => {
                              if (post.commentSamples) {
                                setExpandedPosts(prev => ({
                                  ...prev,
                                  [i]: !prev[i]
                                }));
                              }
                            }}
                          >💬 {fmtNum(post.comments)}</span>
                        </div>
                        {expandedPosts[i] && post.commentSamples && (
                          <ul className="post-comments">
                            {post.commentSamples.map((c, ci) => (
                              <li key={ci} className="post-comment-item">{c}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* 인스타그램 직접 보기 */}
            <a href={`https://www.instagram.com/${profile.username}/`} target="_blank" rel="noreferrer" className="open-btn">
              인스타그램에서 직접 보기 →
            </a>

            {/* API 안내 */}
            <div className="notice notice-info">
              ℹ️ 인스타그램 공식 API 정책에 따라 <strong>프로필 사진 및 실제 게시물 이미지</strong>는 백엔드 서버 운영 시 표시됩니다.
            </div>
          </>
        )}

        {/* API 엔드포인트 안내 */}
        <div className="api-info">
          <div className="api-info-title">Spring Boot API 엔드포인트</div>
          {[
            ["GET", `/api/instagram/profile/{username}`],
            ["GET", `/api/instagram/health`],
          ].map(([m, p]) => (
            <div key={p} className="api-endpoint">
              <span className="api-method">{m}</span>
              <span className="api-path">{p}</span>
            </div>
          ))}
          <p style={{ fontSize: "0.72rem", color: "var(--muted)", marginTop: "0.7rem", fontFamily: "Outfit" }}>
            백엔드 기본 주소: <code style={{ background: "var(--bg)", padding: "1px 5px", borderRadius: "4px" }}>http://localhost:8080</code>
          </p>
        </div>

      </div>
    </>
  );
}
